"use strict";

define('controller/application.settings',['require','exports','module','moment','controller/base','libs/loader.helper','appkit/changes.helper','langs','view/setting/application.settings'],function (require, exports, module) {
  var moment = require('moment');
  var RegionController = require('controller/base');
  var LoaderHelper = require('libs/loader.helper');
  var ChangesHelper = require('appkit/changes.helper');
  var langs = require('langs');
  var ApplicationSettingsView = require('view/setting/application.settings');
  var ApplicationSettingAllController = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: ['PERM_MODIFY_IRB_PROPERTY'],
    initialize: function initialize() {
      this.root = new ApplicationSettingsView({
        formElementOptions: _.bind(this.formElementOptions, this)
      });
      this.settings = this.model('Setting').all(this.app.name);
      this.sectionCollection = new Backbone.Collection([], {
        comparator: 'text'
      });
      this.activeSettings = this.model('Setting').createCollection({});
      this.loaderHelper = new LoaderHelper([this.activeSettings]);
      this.root.collection = this.activeSettings;
    },
    onStart: function onStart() {
      this.configureModelEvents();
      this.configureViewBindings();
      this.configureViewEvents();
      this.state.addPageDependencies([this.settings]);
      this.settings.fetch();
      this.root.$el.css(this.app.config.contentCss);
    },
    onPageLoaded: function onPageLoaded() {
      this.region.show(this.root);
    },
    onPageCancel: function onPageCancel() {
      this.root.destroy();
    },
    onPageExit: function onPageExit() {
      if (this.unsavedChangesModal) {
        this.unsavedChangesModal.destroy();
      }
      if (this.changesHelper) {
        this.changesHelper.off().stopListening();
      }
    },
    configureModelEvents: function configureModelEvents() {
      this.listenTo(this.settings, 'sync', this.onSettingsSync).listenTo(this.activeSettings, 'sync', this.onActiveSettingsSync);
    },
    configureViewEvents: function configureViewEvents() {
      this.listenTo(this.root, 'sidebar:change:selected', function (list, selected, previous) {
        if (!selected || this.unsavedChangesModal && this.unsavedChangesModal.section === selected) {
          return;
        }
        if (this.canChangeSection()) {
          var section = selected.model.get('text');
          this.activeSection = section;
          this.configureViewBySection();
        } else if (this.unsavedChangesModal) {
          this.unsavedChangesModal.section = previous;
          this.unsavedChangesModal.nextSection = selected;
          this.unsavedChangesModal.visible = true;
          _.defer(_.bind(function () {
            this.root.sidebar.selected = previous;
          }, this));
        }
      }).listenTo(this.app.channel, 'change:distractionFreeMode', function () {
        this.root.refreshSticky();
      });
      this.root.on('save:press', this.saveActiveSettings, this);
    },
    getTimezoneSettingFromResponse: function getTimezoneSettingFromResponse(resp) {
      var config = this.app.channel.request('get:config');
      var preferredTimezone;
      if (resp.data && resp.data.length > 0) {
        resp.data.forEach(function (settingItem) {
          if (settingItem.name === config.IRB_TIMEZONE) {
            preferredTimezone = settingItem.value;
          }
        });
        return preferredTimezone;
      }
    },
    saveActiveSettings: function saveActiveSettings() {
      var self = this;
      var xhr = this.activeSettings.save();
      if (xhr) {
        xhr.promise().then(function (resp) {
          var config = this.app.channel.request('get:config');
          var preferredTimezone = self.getTimezoneSettingFromResponse(resp);
          var settingModel = this.app.channel.request('get:setting:model', config.IRB_TIMEZONE);
          if (preferredTimezone && preferredTimezone !== settingModel.get('value')) {
            settingModel.set({
              value: preferredTimezone
            });
          }
          return;
        })["finally"](this.request('dimmer'));
      }
    },
    canChangeSection: function canChangeSection() {
      if (this.changesHelper) {
        return !this.changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
      }
      return true;
    },
    configureViewBySection: function configureViewBySection() {
      var section = this.activeSection;
      if (!section) {
        return;
      }
      this.root.sectionHeader.text = section;
      this.filterActiveSettingsBySection(section);
      if (this.changesHelper) {
        this.changesHelper.stopListening().off();
      }
      if (this.unsavedChangesModal) {
        this.unsavedChangesModal.destroy();
      }
      this.changesHelper = new ChangesHelper();
      this.unsavedChangesModal = this.request('modal', {
        type: 'UNSAVED_CHANGES',
        location: 'section',
        state: this.changesHelper
      }, {
        ariaControlsId: 'applicationSettingsDetails'
      }).on('save:model', this.saveActiveSettings, this).on('proceed', function (action) {
        if (this.unsavedChangesModal && this.unsavedChangesModal.nextSection) {
          this.root.sidebar.selected = this.unsavedChangesModal.nextSection;
        }
      }, this).on('deny', function () {
        this.settings.fetch().promise()["finally"](this.request('dimmer'));
      }, this);
      this.listenTo(this.changesHelper, 'change:' + ChangesHelper.UNSAVED_CHANGES, function () {
        this.root.saveButton.disabled = !this.changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
      });
      this.activeSettings.each(function (setting) {
        this.changesHelper.add(setting);
      }, this);
      this.root.saveButton.disabled = true;
    },
    configureViewBindings: function configureViewBindings() {
      this.root.sidebar.collection = this.sectionCollection;
      this.root.sidebar.childBindings.text = 'text';
      this.root.formElementBindings.value = 'value';
      this.root.formElementBindings.collection = 'choices';
      this.root.formFieldBindings.text = 'description';
      this.root.saveButton.model = this.loaderHelper;
      this.root.saveButton.bindings.loading = 'loading';
    },
    formElementOptions: function formElementOptions(model) {
      return {
        name: model.get('name'),
        toggle: true,
        polar: true,
        inputBindings: {
          value: 'value'
        },
        childBindings: {
          text: 'displayName'
        },
        dropdownValue: function dropdownValue(value, collection) {
          return collection.find(function (choice) {
            return choice.get('description') === value;
          });
        },
        modelValue: function modelValue(value) {
          return value.get('description');
        }
      };
    },
    filterActiveSettingsBySection: function filterActiveSettingsBySection(section) {
      var settings = [];
      this.settings.each(function (setting) {
        var sec = setting.get('section');
        if (sec === section) {
          settings.push(setting);
        }
      });
      this.activeSettings.reset(settings);
    },
    onSettingsSync: function onSettingsSync() {
      var sectionMap = {},
        sections = [];
      this.settings.each(function (setting) {
        var section = setting.get('section');
        if (!section) {
          return;
        }
        if (!sectionMap[section]) {
          sectionMap[section] = true;
          sections.push({
            text: section
          });
        }
      });
      this.sectionCollection.set(sections);
      this.configureViewBySection();
    },
    onActiveSettingsSync: function onActiveSettingsSync() {
      if (this.changesHelper) {
        this.changesHelper.reset();
      }
    }
  });
  module.exports = ApplicationSettingAllController;
});

